import React from 'react';
import {withRouter,} from 'react-router-dom';
import {Location} from 'history';

interface previousProps{
  location:Location
}

class ScrollToTop extends React.PureComponent<any>{
  componentDidMount = () => window.scrollTo(0,0);
  componentDidUpdate = (prevProps:previousProps) =>{
    if(this.props.location !== prevProps.location) window.scrollTo(0,0);
  }
  render = () => this.props.children;
}

export default withRouter(ScrollToTop);